// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type UserFeatureFlagsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserFeatureFlagsQuery = { __typename?: 'Query', userFeatureFlags: Array<{ __typename?: 'FeatureFlag', id: string, releaseVersion: number, type: { __typename?: 'FeatureFlagTypeDetail', code: Types.FeatureFlagType } }> };

export type ProjectFeatureFlagsQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type ProjectFeatureFlagsQuery = { __typename?: 'Query', project: { __typename?: 'StandaloneProject', id: string, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, releaseVersion: number, type: { __typename?: 'FeatureFlagTypeDetail', code: Types.FeatureFlagType } }> } | { __typename?: 'Region', id: string, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, releaseVersion: number, type: { __typename?: 'FeatureFlagTypeDetail', code: Types.FeatureFlagType } }> } | { __typename?: 'Market', id: string, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, releaseVersion: number, type: { __typename?: 'FeatureFlagTypeDetail', code: Types.FeatureFlagType } }> } | { __typename?: 'Community', id: string, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, releaseVersion: number, type: { __typename?: 'FeatureFlagTypeDetail', code: Types.FeatureFlagType } }> } | { __typename?: 'Subdivision', id: string, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, releaseVersion: number, type: { __typename?: 'FeatureFlagTypeDetail', code: Types.FeatureFlagType } }> } | { __typename?: 'Lot', id: string, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, releaseVersion: number, type: { __typename?: 'FeatureFlagTypeDetail', code: Types.FeatureFlagType } }> } | { __typename?: 'Structure', id: string, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, releaseVersion: number, type: { __typename?: 'FeatureFlagTypeDetail', code: Types.FeatureFlagType } }> } | { __typename?: 'Unit', id: string, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, releaseVersion: number, type: { __typename?: 'FeatureFlagTypeDetail', code: Types.FeatureFlagType } }> } };

export type DevelopmentFeatureFlagsQueryVariables = Types.Exact<{
  developmentId: Types.Scalars['ID']['input'];
}>;


export type DevelopmentFeatureFlagsQuery = { __typename?: 'Query', development: { __typename?: 'Development', id: string, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, releaseVersion: number, type: { __typename?: 'FeatureFlagTypeDetail', code: Types.FeatureFlagType } }> } };

export type EnabledFeatureFlagFragment = { __typename?: 'FeatureFlag', id: string, releaseVersion: number, type: { __typename?: 'FeatureFlagTypeDetail', code: Types.FeatureFlagType } };

export const EnabledFeatureFlagFragmentDoc = gql`
    fragment EnabledFeatureFlag on FeatureFlag {
  id
  type {
    code
  }
  releaseVersion
}
    `;
export const UserFeatureFlagsDocument = gql`
    query UserFeatureFlags {
  userFeatureFlags {
    ...EnabledFeatureFlag
  }
}
    ${EnabledFeatureFlagFragmentDoc}`;

/**
 * __useUserFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useUserFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserFeatureFlagsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserFeatureFlagsQuery, UserFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserFeatureFlagsQuery, UserFeatureFlagsQueryVariables>(UserFeatureFlagsDocument, options);
      }
export function useUserFeatureFlagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserFeatureFlagsQuery, UserFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserFeatureFlagsQuery, UserFeatureFlagsQueryVariables>(UserFeatureFlagsDocument, options);
        }
// @ts-ignore
export function useUserFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserFeatureFlagsQuery, UserFeatureFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserFeatureFlagsQuery, UserFeatureFlagsQueryVariables>;
export function useUserFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserFeatureFlagsQuery, UserFeatureFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserFeatureFlagsQuery | undefined, UserFeatureFlagsQueryVariables>;
export function useUserFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserFeatureFlagsQuery, UserFeatureFlagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserFeatureFlagsQuery, UserFeatureFlagsQueryVariables>(UserFeatureFlagsDocument, options);
        }
export type UserFeatureFlagsQueryHookResult = ReturnType<typeof useUserFeatureFlagsQuery>;
export type UserFeatureFlagsLazyQueryHookResult = ReturnType<typeof useUserFeatureFlagsLazyQuery>;
export type UserFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useUserFeatureFlagsSuspenseQuery>;
export type UserFeatureFlagsQueryResult = Apollo.QueryResult<UserFeatureFlagsQuery, UserFeatureFlagsQueryVariables>;
export const ProjectFeatureFlagsDocument = gql`
    query ProjectFeatureFlags($projectId: ID!) {
  project(id: $projectId) {
    id
    featureFlags {
      ...EnabledFeatureFlag
    }
  }
}
    ${EnabledFeatureFlagFragmentDoc}`;

/**
 * __useProjectFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useProjectFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectFeatureFlagsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectFeatureFlagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectFeatureFlagsQuery, ProjectFeatureFlagsQueryVariables> & ({ variables: ProjectFeatureFlagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectFeatureFlagsQuery, ProjectFeatureFlagsQueryVariables>(ProjectFeatureFlagsDocument, options);
      }
export function useProjectFeatureFlagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectFeatureFlagsQuery, ProjectFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectFeatureFlagsQuery, ProjectFeatureFlagsQueryVariables>(ProjectFeatureFlagsDocument, options);
        }
// @ts-ignore
export function useProjectFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectFeatureFlagsQuery, ProjectFeatureFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectFeatureFlagsQuery, ProjectFeatureFlagsQueryVariables>;
export function useProjectFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectFeatureFlagsQuery, ProjectFeatureFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectFeatureFlagsQuery | undefined, ProjectFeatureFlagsQueryVariables>;
export function useProjectFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectFeatureFlagsQuery, ProjectFeatureFlagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectFeatureFlagsQuery, ProjectFeatureFlagsQueryVariables>(ProjectFeatureFlagsDocument, options);
        }
export type ProjectFeatureFlagsQueryHookResult = ReturnType<typeof useProjectFeatureFlagsQuery>;
export type ProjectFeatureFlagsLazyQueryHookResult = ReturnType<typeof useProjectFeatureFlagsLazyQuery>;
export type ProjectFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useProjectFeatureFlagsSuspenseQuery>;
export type ProjectFeatureFlagsQueryResult = Apollo.QueryResult<ProjectFeatureFlagsQuery, ProjectFeatureFlagsQueryVariables>;
export const DevelopmentFeatureFlagsDocument = gql`
    query DevelopmentFeatureFlags($developmentId: ID!) {
  development(id: $developmentId) {
    id
    featureFlags {
      ...EnabledFeatureFlag
    }
  }
}
    ${EnabledFeatureFlagFragmentDoc}`;

/**
 * __useDevelopmentFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useDevelopmentFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevelopmentFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevelopmentFeatureFlagsQuery({
 *   variables: {
 *      developmentId: // value for 'developmentId'
 *   },
 * });
 */
export function useDevelopmentFeatureFlagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DevelopmentFeatureFlagsQuery, DevelopmentFeatureFlagsQueryVariables> & ({ variables: DevelopmentFeatureFlagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DevelopmentFeatureFlagsQuery, DevelopmentFeatureFlagsQueryVariables>(DevelopmentFeatureFlagsDocument, options);
      }
export function useDevelopmentFeatureFlagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DevelopmentFeatureFlagsQuery, DevelopmentFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DevelopmentFeatureFlagsQuery, DevelopmentFeatureFlagsQueryVariables>(DevelopmentFeatureFlagsDocument, options);
        }
// @ts-ignore
export function useDevelopmentFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentFeatureFlagsQuery, DevelopmentFeatureFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DevelopmentFeatureFlagsQuery, DevelopmentFeatureFlagsQueryVariables>;
export function useDevelopmentFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentFeatureFlagsQuery, DevelopmentFeatureFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DevelopmentFeatureFlagsQuery | undefined, DevelopmentFeatureFlagsQueryVariables>;
export function useDevelopmentFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentFeatureFlagsQuery, DevelopmentFeatureFlagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DevelopmentFeatureFlagsQuery, DevelopmentFeatureFlagsQueryVariables>(DevelopmentFeatureFlagsDocument, options);
        }
export type DevelopmentFeatureFlagsQueryHookResult = ReturnType<typeof useDevelopmentFeatureFlagsQuery>;
export type DevelopmentFeatureFlagsLazyQueryHookResult = ReturnType<typeof useDevelopmentFeatureFlagsLazyQuery>;
export type DevelopmentFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useDevelopmentFeatureFlagsSuspenseQuery>;
export type DevelopmentFeatureFlagsQueryResult = Apollo.QueryResult<DevelopmentFeatureFlagsQuery, DevelopmentFeatureFlagsQueryVariables>;